type AppProps = {
  noPadding?: boolean;
  children: any;
};

const ContentArea = ({ children, noPadding }: AppProps) => {
  return (
    <div className="row mt-4">
      <div className="col-md-12">
        <div className={noPadding ? "content-area-no-padding" : "content-area"}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContentArea;
